<template>
	<div class="flex-1">
		<div class="empty-state responsive-item" id="so-empty-search-state">
			<img class="img-fluid" src="../../../assets/icons/empty.svg" alt="">
			<div class="f-16 f-bold">Tidak Menemukan Data</div>
			<div class="f-14 f-c-midgrey">
				Periksa lagi kata yang anda ketik, atau filter yang anda diterapkan.
			</div>
			<button class="btn btn-outline-small bg-white" @click="action">
				<img src="../../../assets/icons/refresh.svg" alt=""> Reset Filter & Pencarian
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOEmptySearchState",
	props: {
		// message: String,
		// subMessage: String,
		// btnText: String,
	},
  mounted() {
    if (document.getElementById("nav-bottom").classList.length > 0) {
      document.getElementById("so-empty-search-state").classList.add("set-responsive");
    }
  },
	methods: {
		action(payload) {
			this.$emit("action", payload)
		}
	}
}
</script>
<style scoped>
@media (min-width: 768px) {
  .set-responsive{
    margin-left: 350px;
    left: 30%;
    top: 230px;
    transform: translateX(-50%);
  }
}
</style>